<div class="height-100 flex-container-column-center bg-auth-accent">
	<div class="text-align-center">
		<ion-spinner name="circular" />
		<p class="mt-3 color-light-gray-on-accent">{{ "auth.signing_out" | translate }}</p>
	</div>
</div>
